import wretch from 'wretch'
import { REACT_APP_CLOUDINARY_API_KEY, REACT_APP_CLOUDINARY_API_SECRET, REACT_APP_CLOUDINARY_CLOUD_NAME } from 'env'
import { sha1Hex } from 'utils/index'

// @see API docs for details https://cloudinary.com/documentation/upload_images
const cloudinaryUploadUrl = `https://api.cloudinary.com/v1_1/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`

// cloudinary image transformation configurations
const crop = 'scale'
const quality = '100:444' // best quality

const getTransformation = (pixelWidth: number, pixelHeight: number) => {
  return `w_${pixelWidth},h_${pixelHeight},c_${crop},q_${quality}`
}

// serialized string must be sorted alphabetically by key https://cloudinary.com/documentation/upload_images#generating_authentication_signatures
const getSerializedString = (pixelWidth: number, pixelHeight: number, timestamp: string) => {
  return `timestamp=${timestamp}&transformation=${getTransformation(
    pixelWidth,
    pixelHeight,
  )}${REACT_APP_CLOUDINARY_API_SECRET}`
}

const getTimestamp = () => {
  return Math.floor((Date.now() / 1000) | 0).toString()
}

const externalService = {
  uploadPhoto: (file: Blob, pixelWidth: number = 500, pixelHeight: number = 500) => {
    const timestamp = getTimestamp()

    return wretch(cloudinaryUploadUrl)
      .formData({
        file,
        transformation: getTransformation(pixelWidth, pixelHeight),
        timestamp,
        api_key: REACT_APP_CLOUDINARY_API_KEY,
        signature: sha1Hex(getSerializedString(pixelWidth, pixelHeight, timestamp)),
      })
      .post()
  },
  // issue with wretch setting Content-Type, so use fetch instead
  uploadImageToPresignedUrl: (url: string, file: Blob) =>
    fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    }),
}

export default externalService
